import Select from "react-select";
import { Fragment, useContext, useEffect, useState } from "react";

import { UserStore } from "../..";
import BreadCrumbs from "../../components/breadcrumsb";
import { PageContainer } from "../../components/page";
import { PEProgressBar } from "../../components/linear-progress";
import { runAuthHandler } from "../util";
import { useNavigate } from "react-router";
import {
  addVenueGeofence,
  deleteVenueGeofence,
  getAllGeofences,
  getGeofencesByVenueId,
  getValidVenues,
} from "../../api/new-api";
import { ErrorAlert } from "../../components/alerts";
import SelectedVenueGeofences from "./SelectedVenueGeofences";
import GeofencesToAdd from "./GeofencesToAdd";
import { observer } from "mobx-react";

const PAGE_TITLE = "Venue Fence Configuration";

const FenceVenueConfigPage = () => {
  const userStore = useContext(UserStore);
  const navigate = useNavigate();
  const { selectedVenue } = userStore;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>("");
  const [venuesOptions, setVenuesOptions] = useState<any>([]);
  const [filteredVenues, setFilteredVenues] = useState<any[]>([]);

  const [allVenues, setAllVenues] = useState<any[]>([]);
  const [venueGeoFences, setVenueGeoFences] = useState<any[]>([]);
  const [selected, setSelected] = useState<any>({
    value: "",
    label: "",
  });

  const fetchValidVenues = async () => {
    setError("");
    try {
      const res = await getValidVenues();
      if (res?.data?.validVenues?.length > 0) {
        setVenuesOptions(res?.data?.validVenues);
        return;
      }
      setError("Something wrong getting venues");
    } catch (err) {
      console.log(err);
      setError("Something wrong getting venues");
    } finally {
      setLoading(false);
    }
  };

  const fetchAllVenues = async () => {
    try {
      const res = await getAllGeofences();
      if (res.data.geofences.length > 0) {
        setAllVenues(res.data.geofences);
        return;
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const fetchVenueGeoFences = async () => {
    setLoading(true);
    setFilteredVenues([]);
    try {
      const res = await getGeofencesByVenueId({ venueId: selected.value });
      setVenueGeoFences(res.data.geofences);

      if (res.data.geofences.length > 0) {
        // Extract locationIds from the geofences
        const existingGeofenceIds = res.data.geofences.map(
          (geofence: { locationId: any }) => geofence.locationId
        );

        // Filter out all venues that have locationIds present in existing geofences
        const filteredVenues = allVenues.filter(
          (venue) => !existingGeofenceIds.includes(venue.locationId)
        );

        setFilteredVenues(filteredVenues);
      }
    } catch (err) {
      console.error("Error fetching geofences:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (locationId: string) => {
    await deleteVenueGeofence({
      venueId: selected.value,
      locationId,
    });

    await fetchVenueGeoFences();
  };

  const handleAdd = async (locationId: string) => {
    await addVenueGeofence({
      venueId: selected.value,
      locationId,
    });
    await fetchVenueGeoFences();
  };

  const handleVenue = () => {
    if (selectedVenue?.venueId !== 17) {
      navigate("/");
    }
  };
  useEffect(() => {
    runAuthHandler({ userStore, navigate });
    fetchValidVenues();
    fetchAllVenues();
    handleVenue();
  }, [selectedVenue]);

  useEffect(() => {
    fetchVenueGeoFences();
  }, [selected]);

  return (
    <PageContainer>
      <BreadCrumbs
        routes={[
          { path: "/home", breadcrumbName: "Home" },
          { path: "/fence-venue-config", breadcrumbName: PAGE_TITLE },
        ]}
      />
      {error && <ErrorAlert message={error} />}

      <div className="text-center mt-10 text-gray-700 dark:text-gray-400">
        <p className="mb-2 font-normal text-2xl">
          {venuesOptions.length} VENUES FOUND
        </p>
        <p className="mb-2 font-normal text-sm italic">
          *select a venue below to view and add geofences
        </p>
        <div>
          {" "}
          <Select
            value={selected}
            options={venuesOptions.map(
              ({
                venueName,
                venueId,
              }: {
                venueName: string;
                venueId: string;
              }) => ({
                value: venueId,
                label: venueName,
              })
            )}
            onChange={(newValue) => setSelected(newValue)}
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {selected.value !== "" && (
            <Fragment>
              <SelectedVenueGeofences
                venues={venueGeoFences}
                handleDelete={handleDelete}
                loading={loading}
              />
              <GeofencesToAdd
                handleAdd={handleAdd}
                venues={venueGeoFences.length > 0 ? filteredVenues : allVenues}
                loading={loading}
              />
            </Fragment>
          )}
        </div>
      </div>
    </PageContainer>
  );
};

export default observer(FenceVenueConfigPage);
